import downloadBlob from 'Utils/DownloadBlob';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

export enum ExportDetectionVariant {
	Default,
	Visua,
	Swiss,
}

export interface PostCreateAndExportDefaultDetectionsRequest {
	videoIds: number[];
	brandGroupIds: number[];
	placementIds: number[];
	withoutPlacement: boolean;
	separateText: boolean;
	startTime: number | null;
	endTime: number | null;
	useAverageDetectionSizePerFrame: boolean;
	combineReports: boolean;
	variant: ExportDetectionVariant;
	includeSummaryLinePerBrandInSwissReport: boolean;
}

const postCreateAndExportDetectionsRequest = async (
	token: string | null,
	request: PostCreateAndExportDefaultDetectionsRequest
): Promise<void> => {
	const url = getApiUrl(ApiUrl.VideosDetectionsExportDefault);
	const axiosInstance = getAxiosInstance(token);
	const response = await axiosInstance.post<Blob>(url, request, { responseType: 'blob' });
	downloadBlob(response.data, response.headers);
};

export default postCreateAndExportDetectionsRequest;
